/** Query: `?source=wp` — external Punjab Skills / WP entry. */
export const PORTAL_SOURCE_WP_STORAGE_KEY = "psda_portal_source_wp";
export const PORTAL_SOURCE_QUERY_PARAM = "source";
export const PORTAL_SOURCE_WP_VALUE = "wp";
